import { Container, Typography } from '@evocolabs/orkaui'
import { ContentTitle, SectionTitle } from '../title'

import AudiologistCall64 from '@evocolabs/icons/lib/AudiologistCall64'
import HandPerson64 from '@evocolabs/icons/lib/HandPerson64'
import { Stack } from '@mui/material'
import theme from '@/src/theme'

const data: {
  title: string
  cardData: Array<{
    title: string
    content: string
    color?: string
    Icon: () => JSX.Element
  }>
} = {
  title: 'Who are Orka Hearing Care Professionals?',
  cardData: [
    {
      title: 'Expertise that Matters',
      content: `With their years of experience in the industry,
      Our partner Hearing Care Professionals will provide guidance and
      answer your questions, ensuring you can hear comfortably.`,
      color: theme.palette.primary[100],
      Icon: AudiologistCall64
    },
    {
      title: 'Personalized Care',
      content: `Your hearing needs are unique, and your solutions
      should reflect that. Experience tailored one-on-one care that
      prioritizes your preferences and lifestyle.`,
      color: theme.palette.secondary[100],
      Icon: HandPerson64
    }
  ]
}
const CallHighlights = (): JSX.Element => {
  return (
    <Container sx={{ mt: { xs: 5, dl: 7 } }}>
      <SectionTitle>{data.title}</SectionTitle>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={3}
        mt={{ xs: 5, dl: 8 }}
      >
        {data.cardData.map(({ title, content, Icon, color }) => (
          <Stack
            alignItems="center"
            flex="1 1 0"
            px={3}
            py={{ xs: 5, sm: 8 }}
            spacing="12px"
            borderRadius="12px"
            bgcolor={color}
            key={title}
          >
            <Icon />
            <ContentTitle color="black">{title}</ContentTitle>
            <Typography mt={1} variant="body2" textAlign="center">
              {content}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Container>
  )
}

export default CallHighlights
